import { FileReader, FileWriter } from '@/platform'
import EventBase from '../EventClass/EventBase'
import { normalizeString, writeIntBool } from '../gameBinUtils'

enum controlType {
    Button = 0,
    String = 1,
    Var = 2,
    Pic = 3,
    Drap = 4,
    Video = 5,
}

class CustomUIItem {
    public EventList: Array<EventBase> = [] //事件列表（仅按钮使用）
    public Type: controlType = controlType.Button //控件的类型
    public IsUserString: boolean = false //是否使用字符串指定路径（仅图片有效）
    public ImagePath1: string = '' //使用的图片路径
    public ImagePath2: string = '' //使用的图片路径2（仅滚动条有效）
    public StringIndex: number = 0 //使用的字符串索引
    public IsUserVar: boolean = false //是否使用变量指定坐标
    public X: number = 0 //x 如果使用变量指定 则是变量索引
    public Y: number = 0 //y 如果使用变量指定 则是变量索引
    public IsUserIndex: boolean | number = this.Type !== controlType.Video ? false : 100 //是否使用索引指定编号（仅按钮有效）
    public Index: number = 0 //变量的索引或者是按钮的索引
    public MaxVar: number = 0 //滚动条的最大值
    public Color: string = '' //字符串与变量显示的时候所用的颜色
    static controlType = controlType

    get VideoPath() {
        if (this.Type === controlType.Video) {
            return this.ImagePath1
        }
        return ''
    }

    set VideoPath(val: string) {
        if (this.Type === controlType.Video) {
            this.ImagePath1 = val
        }
    }

    get ZoomX() {
        if (this.Type === controlType.Video) {
            return this.IsUserIndex
        }
        return 100
    }

    set ZoomX(val) {
        if (this.Type === controlType.Video) {
            this.IsUserIndex = val
        }
    }

    get ZoomY() {
        if (this.Type === controlType.Video) {
            return this.Index
        }
        return 100
    }

    set ZoomY(val) {
        if (this.Type === controlType.Video) {
            this.Index = val
        }
    }

    get Volume() {
        if (this.Type === controlType.Video) {
            return this.MaxVar
        }
        return 100
    }
    set Volume(val) {
        if (this.Type === controlType.Video) {
            this.MaxVar = val
        }
    }

    get IsLoop() {
        if (this.Type === controlType.Video) {
            return parseInt(this.Color)
        }
        return 0
    }

    set IsLoop(val) {
        if (this.Type === controlType.Video) {
            this.Color = val.toString()
        }
    }

    constructor(type?: controlType) {
        if (typeof type == 'number') {
            // this.eventList = new List<EventBase>();
            this.Type = type
        } else {
            // TODO 读取数据
        }
    }

    readBin(reader: FileReader): void {
        const eventLen = reader.readInt()
        this.EventList = []
        this.EventList.length = eventLen
        for (var i = 0; i < eventLen; i++) {
            let event = new EventBase()
            event.readBin(reader)
            this.EventList[i] = event
        }
        this.Type = reader.readInt()
        this.IsUserString = reader.readBool()
        if (this.Type === controlType.Video) {
            this.VideoPath = reader.readString()
        } else {
            this.ImagePath1 = reader.readString()
        }
        this.ImagePath2 = reader.readString()
        this.StringIndex = reader.readInt()
        this.IsUserVar = reader.readBool()
        this.X = reader.readInt()
        this.Y = reader.readInt()
        if (this.Type === controlType.Video) {
            this.ZoomX = reader.readInt()
            this.ZoomY = reader.readInt()
            this.Volume = reader.readInt()
            this.IsLoop = parseInt(reader.readString())
        } else {
            this.IsUserIndex = reader.readBool()
            this.Index = reader.readInt()
            this.MaxVar = reader.readInt()
            this.Color = reader.readString()
        }
    }

    // 数据写入
    writeBin(writer: FileWriter): void {
        writer.writeInt(this.EventList.length)
        for (let i = 0; i < this.EventList.length; i++) {
            var event = this.EventList[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeBin(writer)
        }

        writer.writeInt(this.Type)
        writer.writeBool(this.IsUserString)
        if (this.Type === controlType.Video) {
            writer.writeString(this.VideoPath)
        } else {
            writer.writeString(this.ImagePath1)
        }
        writer.writeString(this.ImagePath2)
        writer.writeInt(this.StringIndex)
        writer.writeBool(this.IsUserVar)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        if (this.Type === 5) {
            writer.writeInt(this.ZoomX as number)
            writer.writeInt(this.ZoomY)
            writer.writeInt(this.Volume)
            writer.writeString(this.IsLoop.toString())
        } else {
            writer.writeBool(this.IsUserIndex as boolean)
            writer.writeInt(this.Index)
            writer.writeInt(this.MaxVar)
            writer.writeString(this.Color)
        }
    }

    readVersionedOui(reader: FileReader): void {
        const eventLen = reader.readInt()
        this.EventList = []
        for (var i = 0; i < eventLen; i++) {
            let event = new EventBase()
            event.readVersionedOui(reader.readObj(reader.readInt()))
            this.EventList.push(event)
        }
        this.Type = reader.readInt()
        this.IsUserString = reader.readInt() ? true : false
        if (this.Type === controlType.Video) {
            this.VideoPath = reader.readString()
        } else {
            this.ImagePath1 = reader.readString()
        }
        this.ImagePath2 = reader.readString()
        this.StringIndex = reader.readInt()
        this.IsUserVar = reader.readInt() === 1
        this.X = reader.readInt()
        this.Y = reader.readInt()
        if (this.Type === controlType.Video) {
            this.ZoomX = reader.readInt()
            this.ZoomY = reader.readInt()
            this.Volume = reader.readInt()
            this.IsLoop = parseInt(reader.readString())
        } else {
            this.IsUserIndex = reader.readInt() === 1
            this.Index = reader.readInt()
            this.MaxVar = reader.readInt()
            this.Color = reader.readString()
        }
    }

    // 数据写入
    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.EventList.length)
        for (let i = 0; i < this.EventList.length; i++) {
            var event = this.EventList[i]
            if (event instanceof EventBase === false) {
                event = Object.assign(new EventBase(), event)
            }
            event.writeVersionedOui(writer)
        }

        writer.writeInt(this.Type)
        writer.writeInt(this.IsUserString ? 1 : 0)
        if (this.Type === controlType.Video) {
            writer.writeString(this.VideoPath)
        } else {
            writer.writeString(this.ImagePath1)
        }
        writer.writeString(this.ImagePath2)
        writer.writeInt(this.StringIndex)
        writer.writeInt(this.IsUserVar ? 1 : 0)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)
        if (this.Type === 5) {
            writer.writeInt(this.ZoomX as number)
            writer.writeInt(this.ZoomY)
            writer.writeInt(this.Volume)
            writer.writeString(this.IsLoop.toString())
        } else {
            writer.writeInt(this.IsUserIndex ? 1 : 0)
            writer.writeInt(this.Index)
            writer.writeInt(this.MaxVar)
            writer.writeString(this.Color)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.EventList.length)
        for (let i = 0; i < this.EventList.length; i++) {
            const event = this.EventList[i] instanceof EventBase
                ? this.EventList[i]
                : Object.assign(new EventBase(), this.EventList[i] as Partial<EventBase>)
            event?.writeGameBin(writer)
        }

        writer.writeInt(this.Type)
        writeIntBool(writer, this.IsUserString)
        writer.writeString(normalizeString(this.Type === controlType.Video ? this.VideoPath : this.ImagePath1))
        writer.writeString(normalizeString(this.ImagePath2))
        writer.writeInt(this.StringIndex)
        writeIntBool(writer, this.IsUserVar)
        writer.writeInt(this.X)
        writer.writeInt(this.Y)

        if (this.Type === controlType.Video) {
            writer.writeInt(typeof this.IsUserIndex === 'number' ? this.IsUserIndex : 0)
        } else {
            writeIntBool(writer, this.IsUserIndex)
        }
        writer.writeInt(this.Index)
        writer.writeInt(this.MaxVar)
        writer.writeString(normalizeString(this.Color))
        writer.writerLength()
    }
}

export default CustomUIItem
